import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { TransmissionRunEntity } from './transmission-run.model';

export enum TransmissionRunActionTypes {
  LoadTransmissionRuns = '[TransmissionRun] Load TransmissionRuns',
  AddTransmissionRun = '[TransmissionRun] Add TransmissionRun',
  UpsertTransmissionRun = '[TransmissionRun] Upsert TransmissionRun',
  AddTransmissionRuns = '[TransmissionRun] Add TransmissionRuns',
  UpsertTransmissionRuns = '[TransmissionRun] Upsert TransmissionRuns',
  UpdateTransmissionRun = '[TransmissionRun] Update TransmissionRun',
  UpdateTransmissionRuns = '[TransmissionRun] Update TransmissionRuns',
  DeleteTransmissionRun = '[TransmissionRun] Delete TransmissionRun',
  DeleteTransmissionRuns = '[TransmissionRun] Delete TransmissionRuns',
  ClearTransmissionRuns = '[TransmissionRun] Clear TransmissionRuns',
}

export class LoadTransmissionRuns implements Action {
  public readonly type = TransmissionRunActionTypes.LoadTransmissionRuns;

  constructor(public payload: { transmissionRuns: TransmissionRunEntity[] }) {}
}

export class AddTransmissionRun implements Action {
  public readonly type = TransmissionRunActionTypes.AddTransmissionRun;

  constructor(public payload: { transmissionRun: TransmissionRunEntity }) {}
}

export class UpsertTransmissionRun implements Action {
  public readonly type = TransmissionRunActionTypes.UpsertTransmissionRun;

  constructor(public payload: { transmissionRun: TransmissionRunEntity }) {}
}

export class AddTransmissionRuns implements Action {
  public readonly type = TransmissionRunActionTypes.AddTransmissionRuns;

  constructor(public payload: { transmissionRuns: TransmissionRunEntity[] }) {}
}

export class UpsertTransmissionRuns implements Action {
  public readonly type = TransmissionRunActionTypes.UpsertTransmissionRuns;

  constructor(public payload: { transmissionRuns: TransmissionRunEntity[] }) {}
}

export class UpdateTransmissionRun implements Action {
  public readonly type = TransmissionRunActionTypes.UpdateTransmissionRun;

  constructor(public payload: { transmissionRun: Update<TransmissionRunEntity> }) {}
}

export class UpdateTransmissionRuns implements Action {
  public readonly type = TransmissionRunActionTypes.UpdateTransmissionRuns;

  constructor(public payload: { transmissionRuns: Update<TransmissionRunEntity>[] }) {}
}

export class DeleteTransmissionRun implements Action {
  public readonly type = TransmissionRunActionTypes.DeleteTransmissionRun;

  constructor(public payload: { id: string }) {}
}

export class DeleteTransmissionRuns implements Action {
  public readonly type = TransmissionRunActionTypes.DeleteTransmissionRuns;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearTransmissionRuns implements Action {
  public readonly type = TransmissionRunActionTypes.ClearTransmissionRuns;
}

export type TransmissionRunActions =
  | LoadTransmissionRuns
  | AddTransmissionRun
  | UpsertTransmissionRun
  | AddTransmissionRuns
  | UpsertTransmissionRuns
  | UpdateTransmissionRun
  | UpdateTransmissionRuns
  | DeleteTransmissionRun
  | DeleteTransmissionRuns
  | ClearTransmissionRuns;
